const riot = require('riot');

riot.tag2('page-index', '<div class="s-full"></div>', 'page-index,[data-is="page-index"]{display:block}', '', function(opts) {
    this.preload =  async () => {

      if (app.utils.auth.currentUser) {
        var user = app.utils.auth.currentUser;
        if (user.role === 'operator') {
          spat.router.replace('/admin/companies');
        }
        else if (user.role === 'client') {
          var { companies } = await app.api.child('me/companies').get({ limit: 1, offset: 0 });

          var company = companies[0];
          spat.router.replace(`/app/companies/${company.id}/projects`);
        }
      }
    };
});